<template>
  <div
    v-if="!isConfirmCookie"
    class="vz-cookies"
  >
    <div class="vz-cookies-content">
      <div class="vz-cookies-content-description">
        Для обеспечения функциональности сайта используем файлы куки.
        <a
          target="_blank"
          :href="linkCountryCookie"
          download
        >
          Подробнее
        </a>
      </div>

      <vz-button
        class="vz-cookies-content-button"
        big
        @click="acceptCookies"
      >
        Принять
      </vz-button>
    </div>
  </div>
</template>

<script setup lang="ts">
import {cookiePolicy} from "~/api/constant-urls";
import VzButton from "~/components/ui-kit/vz-button.vue";
import {useDomainCountry} from "~/composables/states";

const isConfirmCookie = useCookie<boolean>('_vz_confirm_cookie', {expires: new Date('2040-01-01')})

const linkCountryCookie = computed(() => {
  const country = useDomainCountry().value.toLowerCase() === 'kg'? 'ru' : useDomainCountry().value.toLowerCase()
  return `https://vozovoz.${country}${cookiePolicy}`
})

function acceptCookies() {
  isConfirmCookie.value = true
}
</script>

<style lang="scss">
.vz-cookies {
  display: flex;
  z-index: 2050;
  justify-content: center;
  background: #657D95;
  padding: 20px 0;
  position: fixed;
  bottom: 0;
  width: 100%;

  &-content {
    width: 907px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    &-description {
      display: flex;
      flex-direction: column;
      gap: 4px;
      font-size: 16px;
      color: #FFFFFF;

      a {
        text-decoration: underline;
        color: #D9DCDE;
      }
    }

    &-button {
      color: #657D95;
      width: 161px;
      justify-content: center;
      background-color: #ffffff;

      &:hover {
        background-color: #b8cadc !important;
        border-color: transparent !important;
        color: #333333 !important;
      }
    }

    @media screen and (max-width: 1087px) {
      flex-direction: column;
      align-items: center;
      gap: 24px;
      padding: 0 10px;

      &-description {
        justify-content: center;
        text-align: center;
      }
    }
  }
}
</style>
